import * as React from "react";
import logo from '../../images/logo.png'
import welcome from '../../images/welcome.png'

const Header: React.FC = () => {
    return (
        <div className='mainheader'>
      <span id="logo" className="grid-2">
        <a href="http://www.clearstream.com" target="_blank" rel="noreferrer">
          <img
              src={logo}
              width="176"
              height="30"
              alt="Clearstream Logo"
          />
        </a>
      </span>
            <span id="welcome" className="grid-6">
        <img
            src={welcome}
            width="550"
            height="30"
            alt="Welcome to Clearstream. Part of Deutsche Boerse Group"
        />
      </span>
        </div>
    );
};

export default Header;


